import * as React from 'react';

export function SvgChromeLogo(props: any) {
  return (
    <svg
      width="96"
      height="97"
      viewBox="0 0 96 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2_3878)">
        <path
          d="M48.001 72.4349C61.2566 72.4349 72.002 61.6889 72.002 48.4334C72.002 35.1778 61.2566 24.4319 48.001 24.4319C34.7454 24.4319 24 35.1778 24 48.4334C24 61.6889 34.7454 72.4349 48.001 72.4349Z"
          fill="white"
        />
        <path
          d="M27.2151 60.4397L6.43276 24.4435C2.21883 31.74 0 40.0171 0 48.4435C0 56.8698 2.21783 65.147 6.43125 72.4435C10.6447 79.74 16.705 85.7993 24.0025 90.0107C31.3 94.2221 39.5782 96.4384 48.004 96.4359L68.7864 60.4397V60.4342C66.6815 64.0847 63.6523 67.1164 60.0038 69.2243C56.3553 71.3322 52.2161 72.4423 48.0025 72.4429C43.7889 72.4435 39.6494 71.3347 36.0003 69.2279C32.3512 67.1209 29.3213 64.0902 27.2151 60.4407V60.4397Z"
          fill="#229342"
        />
        <path
          d="M68.7849 60.4382L48.003 96.4344C56.4288 96.4359 64.7065 94.2181 72.0035 90.0057C79.3005 85.7933 85.3599 79.7334 89.5723 72.4359C93.7845 65.1385 96.0013 56.8608 96 48.4349C95.9985 40.0091 93.7786 31.7319 89.5637 24.4359H47.9995L47.9944 24.4395C52.2081 24.4374 56.3479 25.5449 59.9977 27.6505C63.6477 29.7565 66.6784 32.7856 68.7859 36.4347C70.8932 40.0836 72.0027 44.223 72.0026 48.4367C72.0025 52.6505 70.8929 56.7899 68.7854 60.4387L68.7849 60.4382Z"
          fill="#FBC116"
        />
        <path
          d="M48.001 67.4399C58.495 67.4399 67.002 58.9329 67.002 48.4385C67.002 37.944 58.495 29.4375 48.001 29.4375C37.507 29.4375 29.0001 37.9445 29.0001 48.4385C29.0001 58.9324 37.507 67.4399 48.001 67.4399Z"
          fill="#1A73E8"
        />
        <path
          d="M48.001 24.4374H89.5652C85.3533 17.1399 79.2945 11.0796 71.9975 6.86615C64.7007 2.65302 56.4233 0.435274 47.9975 0.435913C39.5717 0.436417 31.2945 2.65527 23.9985 6.86969C16.7022 11.0839 10.6441 17.1448 6.43326 24.443L27.2156 60.4392L27.2212 60.4422C25.1126 56.794 24.0018 52.6549 24.0004 48.4412C23.9991 44.2275 25.1073 40.0877 27.2136 36.4382C29.3196 32.7887 32.3502 29.758 35.9992 27.6515C39.6483 25.5451 43.7881 24.4359 48.002 24.4369L48.001 24.4374Z"
          fill="#E33B2E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_3878">
          <rect
            width="96"
            height="96"
            fill="white"
            transform="translate(0 0.435913)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
